import React, { forwardRef, useState, useEffect } from 'react';

const IosCompatibleInput = forwardRef(({
  type = 'text',
  id,
  name,
  value,
  onChange,
  debounce = 300, // ms (ajout 22/07/2025)
  required = false,
  ...props
}, ref) => {

const [internalValue, setInternalValue] = useState(value);

// Met à jour la valeur interne si le parent change (ex: reset) (ajout 22/07/2025)
  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  // Applique un debounce au callback parent (ajout 22/07/2025)
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (internalValue !== value && onChange) {
  //       onChange({ target: { value: internalValue, name, id } });
  //     }
  //   }, debounce);

  //   return () => clearTimeout(timer);
  // }, [internalValue]);

  // Test avec les dépendances (modif du 31/07/2025)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (internalValue !== value && onChange) {
        onChange({ target: { value: internalValue, name, id } });
      }
    }, debounce);

    return () => clearTimeout(timer);
  }, [internalValue, debounce, id, name, onChange, value]);

  // (ajout 22/07/2025)
  const handleChange = (e) => {
    setInternalValue(e.target.value);
  };

  // const handleChange = (e) => { // commenté le (ajout 22/07/2025)
  //   if (onChange) {
  //     onChange(e);
  //   }
  // };

  return (
    <input
      ref={ref}
      type={type}
      id={id}
      name={name}
      value={internalValue} // valeur totalement contrôlée (modification du 22/07/2025 value => internalValue)
      onChange={handleChange}
      required={required}
      autoComplete="new-password"
      autoCorrect="off"
      autoCapitalize="none"
      spellCheck="false"
      data-lpignore="true"
      {...props}
    />
  );
});

export default IosCompatibleInput;

